import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    Logs: "",
    SessionPersistData: {}
}
const apicommunicationSlice = createSlice({
    name: "apicommunication",
    initialState,
    reducers: {
        SetSessionPersistData: (state, action) => {
            state.SessionPersistData[action.payload.name] = action.payload.data;
        }
    }
});

export const { SetSessionPersistData } = apicommunicationSlice.actions;
export default apicommunicationSlice.reducer;
